import React from "react";
import "./Black_btn.css";
import { Link } from "react-router-dom";

const Black_btn = ({ btn_name, btn_link, onClick, type = "button" }) => {

    if (type === "submit" || !btn_link) {
        // Submit or normal button
        return (
            <button
                className="black_btn"
                onClick={onClick}
                type={type}
            >
                {btn_name}
            </button>
        );
    }

    // Link button
    return (
        <section className="Black_btn_sec">
            <Link to={btn_link}>
                <button className="black_btn" type="button">
                    {btn_name}
                </button>
            </Link>
        </section>
    );

};

export default Black_btn;
